import qs from 'qs';
import { BuyingMapFilter, BuyingMarker } from 'types/buying';
import { get } from './clientAxios';

export async function getBuyingMarkerInformations(mapData: BuyingMapFilter) {
  try {
    const response = await get<BuyingMarker[]>('/api/buying/v3-3/map-list', {
      params: mapData,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}
